module.exports = __webpack_public_path__ + "media/images/icons/country_flags/mh-cd62f8f2afec11d2e1195fb13bb83492.svg";